<template>
  <div class="tutorial">
    <div class="box">
      <div class="nav">
        <div class="title-box">Tutorials</div>
        <div class="close-box">
          <font-awesome-icon :icon="['fas', 'times']" class="icon" @click="close"/>
        </div>
      </div>

      <div class="list">
        <Question index="1" :active="activeQuestion" videoId="SW1X5kVEVdk" title="How to create a simple dialogue?" @open="onOpen" @close="onClose"/>
        <Question index="2" :active="activeQuestion" videoId="RBV9G2jb2sI" title="How to share a dialogue with students?" @open="onOpen" @close="onClose"/>
        <Question index="3" :active="activeQuestion" videoId="QXcCZ9weTWg" title="How Play - Learn - Record works?" @open="onOpen" @close="onClose"/>
        <Question index="4" :active="activeQuestion" title="Advanced dialogue features." @open="onOpen" @close="onClose"/>
      </div>

    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters} from 'vuex'
import Question from './Question'

export default {
  name: 'Tutorial',
  data() {
    return {
      activeQuestion: null,
    }
  },
  components: {
    Question
  },
  methods: {
    ...mapActions('tutorials', ['closeTutorial']),
    close() {
      this.closeTutorial();
    },
    onOpen(index) {
      this.activeQuestion = index;
    },
    onClose() {
      this.activeQuestion = null;
    }
  },
  computed: {
    ...mapGetters('tutorials', ['getQuestionIndex']),
  },
  mounted() {
    if(this.getQuestionIndex) {
      this.activeQuestion = this.getQuestionIndex;
    }
  }
}
</script>

.<style lang="scss" scoped>
.tutorial {
  position: fixed;
  z-index: 100;
  width: 100%;
  min-height: 100vh;
  background-color: rgba(0, 0, 0, 0.425);
  display: flex;
  justify-content: center;
  align-items: center;

  .box {
    width: 60rem;
    height: auto;
    max-height: 90vh;
    background-color: white;
    border-radius: 0.3rem;
    overflow-y: auto;
    overflow-x: hidden;
    @media (max-width: 1000px) {
      width: 90vw;
    }
    &::-webkit-scrollbar {
      width: 0.5rem;
    }
    
    &::-webkit-scrollbar-track {
      background-color: white;
    }
    
    &::-webkit-scrollbar-thumb {
      background-color: #11b6a5;
    }
  }

  .nav {
    position: fixed;
    width: 60rem;
    height: 5rem;
    background-color: #11b6a5;
    display: flex;
    @media (max-width: 1000px) {
      width: 90vw;
    }
    z-index: 10;
    .title-box {
      width: auto;
      height: 100%;
      margin-left: 1.5rem;
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
      font-size: 1.5rem;
      font-weight: bold;
    }
    .close-box {
      width: 5rem;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: auto;

      .icon {
        color: white;
        font-size: 1.5rem;
        transition: 0.2s;

        &:hover {
          opacity: 0.8;
          cursor: pointer;
        }
      }
    }
  }

  .list {
    margin-top: 5rem;
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 2rem;
    padding-bottom: 3rem;

    @media (max-width: 500px) {
      padding-top: 1rem;
      padding-bottom: 2rem;
    }
  }
}
</style>